import { VenetianMask, X } from 'lucide-react'

import { useDiscardIncognito } from '@/api/hooks'
import { toast } from '@/components/ui'
import { useIncognito } from '@/lib/incognito'

/**
 * The reminder that you are in incognito.
 *
 * Not decoration. This mode deletes what you play, so being in it without
 * realising is the one genuinely costly mistake available — a browser shows a
 * private window differently for the same reason. It sits directly above the
 * player rather than at the top of the page so it survives scrolling and cannot
 * be mistaken for part of whatever page you happen to be on.
 */
export function IncognitoBanner() {
  const { active, set } = useIncognito()
  const discard = useDiscardIncognito()

  if (!active) return null

  function turnOff() {
    discard.mutate(undefined, {
      onSuccess: (result) => {
        set(false)
        toast.success(
          'Incognito off',
          result.discarded > 0
            ? `Discarded ${result.discarded} ${result.discarded === 1 ? 'song' : 'songs'}.`
            : 'Nothing to discard.',
        )
      },
      onError: () => toast.error('Could not clear the session', 'Nothing was deleted.'),
    })
  }

  return (
    <div className="h-banner flex items-center gap-2 border-b border-border bg-accent-soft px-4">
      <VenetianMask className="h-4 w-4 shrink-0 text-accent" aria-hidden="true" />
      <p className="min-w-0 flex-1 truncate text-xs font-medium text-accent">
        Incognito — not saving to your library
      </p>
      <button
        type="button"
        onClick={turnOff}
        disabled={discard.isPending}
        className="flex h-8 shrink-0 items-center gap-1 rounded-md px-2 text-xs font-medium text-accent hover:bg-surface-hover disabled:opacity-50"
      >
        <X className="h-3.5 w-3.5" aria-hidden="true" />
        Turn off
      </button>
    </div>
  )
}
